function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
}

export function createdAtToUTC(created_at) {
    if (! created_at) {
        return ""
    }

    let date = new Date(`${created_at.replace(/-/g, "/")}-0600`);
    return `${created_at.substring(0, 10)} ${padTo2Digits(date.getUTCHours())}:${padTo2Digits(date.getUTCMinutes())}:${padTo2Digits(date.getUTCSeconds())}`;
}